import { Theme } from '@silvertours/front-shared';
import { useMedia } from 'react-use';
import { SearchForm } from '../SearchFormLegacy';
import { SearchContainer } from '../StageLegacy/SearchContainer';
import { FullForm, WizardCard } from './HomeSearchMask.styles';

type HomeSearchMaskProps = {
  headline: string;
  buttonLabel: string;
};

const mdBreakpoint = Theme.getBreakpoint('md') ?? 768;

/**
 * The search mask of the index page variant. It reuses the existing search
 * components, so the search logic does not change.
 * Below md it shows the card that opens the search wizard, from md the full
 * form. CSS selects the version, so the page does not shift on hydration.
 *
 * The wizard and the legacy form use the same element IDs (for example "dep"
 * and "find"). Thus, after hydration, the hidden version is removed from the
 * DOM. On the server and during hydration, no media query matches (default
 * `false`), so both versions render and the HTML stays the same.
 */
const HomeSearchMask = ({ headline, buttonLabel }: HomeSearchMaskProps) => {
  const isBelowMd = useMedia(`(max-width: ${mdBreakpoint - 1}px)`, false);
  const isFromMd = useMedia(`(min-width: ${mdBreakpoint}px)`, false);

  return (
    <>
      {!isFromMd && (
        <WizardCard data-testid="home-search-wizard">
          <SearchContainer
            layout="card"
            includeSearch
            headline={headline}
            buttonLabel={buttonLabel}
          />
        </WizardCard>
      )}
      {!isBelowMd && (
        <FullForm data-testid="home-search-form">
          <SearchForm isWide layout="card" headline={headline} />
        </FullForm>
      )}
    </>
  );
};

export { HomeSearchMask };
export type { HomeSearchMaskProps };
